<div class="p-3 rounded-3">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="titletoptables d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center">
          <div class="leftsideicons">
            <img src="../../assets/image/error-log.png" alt="error-log" onkeydown="" />
          </div>
          <h3 class="mb-0">{{ "Login Logs" }}</h3>
        </div>
        <div class="d-flex align-items-end gap-2">
          <div class="d-flex flex-column">
            <label class="dp-label">Start Date</label>
            <app-date-picker style="width: 160px;" [(ngModel)]="startDate"></app-date-picker>
          </div>
          <div class="d-flex flex-column">
            <label class="dp-label">End Date</label>
            <app-date-picker style="width: 160px;" [(ngModel)]="endDate"></app-date-picker>
          </div>
          <button type="button" class="btn btn-primary" (click)="loadData()">Apply</button>
        </div>
      </div>
    </div>
  </div>
  <div class="grid-card">
    <div class="filters-bar">
      <div class="filter-search">
        <app-search-input [value]="searchString" (valueChange)="filterData($event)" (cleared)="clearList()"></app-search-input>
      </div>
    </div>
    <app-data-grid>
    <kendo-grid #grid  [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false" [sort]="sort"
      (sortChange)="gridData ? sortChange($event): null" [resizable]="true" [reorderable]="true" filterable="menu"
      [filter]="state.filter" [selectable]="true" (dataStateChange)="gridData ? dataStateChange($event): null"
      (columnVisibilityChange)="onColumnVisibilityChange(grid)" [groupable]="true" [group]="state.group"
      [navigable]="true" [height]="gridHeight">
      <kendo-grid-column field="CompanyId" title="CompanyId" filter="numeric" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="Username" title="Username" [width]='30'>
      </kendo-grid-column>
      <kendo-grid-column field="IpAddress" title="IpAddress" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="Location" title="Location" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="DeviceType" title="DeviceType" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="LoginTime" title="LoginTime" filter="date" format="yyyy-MM-dd" [width]='20'>
      </kendo-grid-column>
      <kendo-grid-column field="Domain" title="Domain" [width]='20'>
      </kendo-grid-column>
    </kendo-grid>
    </app-data-grid>
  </div>
</div>